import React from 'react';
import styled, { keyframes } from 'styled-components';
import { Input, InputGroup, InputRightElement, Button } from '@chakra-ui/react';

function setFilterInput({ inputValue, filter, setFilters }) {
	const newFilters = { ...filter };
	newFilters['textFilter'] = inputValue ? inputValue : '';
	setFilters(newFilters);
}

function onChangeHandler({ e, setInputValue, filter, setFilters }) {
	const value = e.target.value;
	setInputValue(value);
	if (!value) {
		setFilterInput({ inputValue: value, filter, setFilters });
	}
}

//originalData como array
//setParsedData função para escrever como state o resultado do filter
const SearchBar = ({ filter, setFilters, placeholder, inputFS }) => {
	const [inputValue, setInputValue] = React.useState('');

	return (
		<InputGroup size={'md'} display="flex" minW="440px" flexBasis={'28%'}>
			<Input
				focusBorderColor={'yellow.400'}
				pr="4.5rem"
				fontSize={inputFS ? inputFS : 'md'}
				type={'text'}
				placeholder={placeholder ? placeholder : 'Procure por nome, usuário, etc...'}
				onChange={(e) => {
					onChangeHandler({ e, setInputValue, filter, setFilters });
				}}
				borderColor={'gray.300'}
				value={inputValue}
			/>
			<InputRightElement width="5.5rem">
				<Button
					sx={{
						fontWeight: 'normal',
						width: '100%',
						borderRadius: '0 8px 8px 0',
						border: '1px solid rgb(203, 213, 224)',
					}}
					onClick={() => setFilterInput({ inputValue, filter, setFilters })}
				>
					Buscar
				</Button>
			</InputRightElement>
		</InputGroup>
	);
};

export default SearchBar;
